import * as Yup from 'yup';

const ValidationSchema = ({ t }) => Yup.object().shape({
  title: Yup.string()
    .typeError('Field must be string !')
    .required(t('general.message.field_required')),
  input_type: Yup.string()
    .typeError('Field must be string !')
    .required(t('general.message.field_required')),
});

export default ValidationSchema;
